export const initCopyToClipboard = () => {
    const copyPaths = document.querySelectorAll(".copy-to-clipboard");
    if (!copyPaths) {
        return;
    }
    copyPaths.forEach((copyPath) => {
        const text = copyPath.dataset.clipboardText ? copyPath.dataset.clipboardText : '';
        copyPath.addEventListener("click", () => {
            navigator.clipboard.writeText(text).then(() => {
                /* clipboard successfully set */
                alert(copyPath.dataset.clipboardSuccessText);
            }, () => {
                /* clipboard write failed */
                alert("Copying to clipboard failed. Please manually copy the text.");
            });
        });
    });
};
